/**
 * External dependencies
 */
import React from 'react';
import { Stack, Text } from '@towersystems/towersystems-design-system';
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import AnnotatedSection from 'components/annotated-section';
import FormInputCheckbox from 'components/forms/form-checkbox';
import ExportSale from './export-sale';
import ExportMetaData from './export-meta-data';
import GeneralSettings from './general-settings';
import FormTextInput from 'components/forms/form-text-input';
import FormLabel from 'components/forms/form-label';

const RoamRender = ({
	handleOnGeneralSettingsChange,
	handleOnChangeInputBox,
	exportNewSales,
	handleOnChangeCheckbox,
	connectionGroupCode,
	terminals,
	paytypes,
	values,
	metaData,
	connectionId,
	connectionType,
	...props
}) => {
	return (
		<Stack space='medium'>
			<Stack space='xlarge' dividers>
				<AnnotatedSection>
					<AnnotatedSection.Annotation
						title='Automatic sales export'
						description='Configure how sales are exported from your eCommerce platform.'
					/>
					<AnnotatedSection.Content>
						<Stack space='xlarge'>
							<Card>
								<Card.Section>
									<FormInputCheckbox
										label='Automatic sales export'
										onChange={handleOnChangeCheckbox}
										name='automaticSalesExport'
										checked={get(values, 'automaticSalesExport', false)}
									>
										When ticked, new sales marked as <b>paid</b> will automatically be downloaded
										from your eCommerce platform.
									</FormInputCheckbox>
								</Card.Section>
							</Card>
							<Card>
								<Card.Section>
									<FormLabel>Start Date:</FormLabel>
									<Text size='xsmall'>
										The start date you would like to export order from. Please use format YYYY-MM-DD
										HH:MM:SS (in 24 hour time). When leave blank, orders newer than current time
										will be exported by default.
									</Text>
									<FormTextInput
										name='saleStartDate'
										value={get(values, 'saleStartDate')}
										onChange={handleOnChangeInputBox}
									/>
								</Card.Section>
							</Card>
							<Card>
								<Card.Section>
									<ExportMetaData exportNewSales={exportNewSales} metaData={metaData} />
								</Card.Section>
							</Card>
						</Stack>
					</AnnotatedSection.Content>
				</AnnotatedSection>
				<AnnotatedSection>
					<AnnotatedSection.Annotation
						title='Manual sales export'
						description='Manually check for new sales from your eCommerce platform using identifier.'
					/>
					<AnnotatedSection.Content>
						<Stack space='xlarge'>
							<Card>
								<Card.Section>
									<ExportSale connectionId={connectionId} connectionType={connectionType} />
								</Card.Section>
							</Card>
						</Stack>
					</AnnotatedSection.Content>
				</AnnotatedSection>
			</Stack>
		</Stack>
	);
};

export default RoamRender;
